const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

document.querySelectorAll(".element-calloutscroll").forEach((el) => {
  if (prefersReducedMotion) return;

  const items = el.querySelectorAll("[data-scroll-item]");

  if (items.length < 2) return;

  const setActive = (target) => {
    items.forEach((item) => item.classList.toggle("is-active", item === target));
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActive(entry.target);
        }
      });
    },
    { rootMargin: "-50% 0px -50% 0px", threshold: 0 },
  );

  items.forEach((item) => observer.observe(item));
});
